<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 24/9/2020
  -->

<template>
	<RemoteButton v-bind="$attrs"
				  :classSuccess="['text-default']"
				  type="primary"
				  title="Save"
				  titleProcessing="Saving..."
				  titleSuccess="Saved"/>
</template>

<script>
import RemoteButton from "@/core/components/Controls/Buttons/RemoteButton.vue";
export default {
	name: "SaveButton",
	components: {RemoteButton},
}
</script>

<style lang="scss">

</style>
